/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractCancelRequest = {
  properties: {
    contractId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
